/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function() {
  var categorySliderObj = document.querySelector(".category-slider");
  if(categorySliderObj) {
    var categorySlider = new Flickity( categorySliderObj, {
      groupCells: true,
      groupCells: 1
    });
  }

  var categorySliderObj = document.querySelectorAll(".slider");
  if(categorySliderObj) {
    categorySliderObj.forEach(function(slider) {
      var categorySlider = new Flickity( slider, {
        on: {
          ready: function ready() {
            setTimeout(function() {
              categorySlider.resize();
            }, 1500);
            
            $(window).on("scroll", function() {
              categorySlider.resize();
            });
          }()
        }
      });
    });
  }

  
  var featuredCollectionSliders = document.querySelectorAll(".featuredCollectionSlider");
  if(featuredCollectionSliders) {
    featuredCollectionSliders.forEach(function(slider) {
      var featuredCollectionSlider = new Flickity( slider, {
        prevNextButtons: true,
        pageDots: false,
        wrapAround: true,
        groupCells: $(window).width() < 767 ? 1 : 4
      });
    });
  }
  
  if($(window).width() > 767) {
    var collectionListSliders = document.querySelectorAll(".CollectionList");
    if(collectionListSliders) {
      collectionListSliders.forEach(function(slider) {
        var collectionListSlider = new Flickity( slider, {
          prevNextButtons: true,
          pageDots: false,
          wrapAround: true,
          groupCells: 5
        });
      });
    }
  }
  
  
  
  // Color Slider on (Get Inspired) Page
  var colorSliders = document.querySelectorAll(".color-slider");
  colorSliders.forEach(function(slider) {
    var colorSlider = new Flickity( slider, {
      groupCells: true,
      groupCells: 1
    });
  });
  
  setTimeout(function() {
    // Instagram Slider on Home Page 
    var instaGalleryObj = document.querySelector(".instagram_gallery");
      if(instaGalleryObj) {
        var instaGallery = new Flickity( instaGalleryObj, {
          groupCells: true,
          groupCells: $(window).width() < 767 ? 1 : 4
        });
      }
      else {
        var iterations = 0;
        var interval = setInterval(igFlick, 500)
        function igFlick() {
          iterations++
          instaGalleryObj = document.querySelector(".instagram_gallery");
          if(instaGalleryObj) {
            var instaGallery = new Flickity( instaGalleryObj, {
              groupCells: true,
              groupCells: $(window).width() < 767 ? 1 : 4
            });
            clearInterval(interval)
          }
          if(iterations > 5) {
            clearInterval(interval)
          }
        }
      }
    }, 1000)

    // Product Recommendation Slider on Product Page 
  setTimeout(function() {
    var recommendedSlider = document.querySelector('.recommenationSlider')
    if(recommendedSlider) {
      var recomm_slider = new Flickity( '.recommenationSlider', {
        prevNextButtons: true,
        pageDots: false,
        wrapAround: true,
        groupCells: $(window).width() < 767 ? 2 : 4
      });
    }
    else {
      var iterations = 0;
      var interval = setInterval(recFlick, 500)
      function recFlick() {
        iterations++
        

        if(document.querySelector('.recommenationSlider')) {
          
          var recomm_slider = new Flickity( '.recommenationSlider', {
            prevNextButtons: true,
            pageDots: false,
            wrapAround: true,
            groupCells: $(window).width() < 767 ? 2 : 4
          });
          
          if(iterations > 5) {
            clearInterval(interval);
          }
        }
      }
    }
    
  }, 1000)
    
    // Color variants slider on Product Page
  setTimeout(function() {
    var productColors = document.querySelector('#color_options_slider')
    if(productColors) {
      var productColorOptions = new Flickity( '#color_options_slider', {
      prevNextButtons: true,
      pageDots: false,
      wrapAround: true,
      groupCells: 4,
      cellAlign: 'left'
    });
    }
    else {
      var iterations = 0;
      var interval = setInterval(colFlick, 500)
      function colFlick() {
        iterations++
        if(document.querySelector('#color_options_slider')) {
          var productColorOptions = new Flickity( '#color_options_slider', {
            prevNextButtons: true,
            pageDots: false,
            wrapAround: true,
            groupCells: 4,
            cellAlign: 'left'
            });
          clearInterval(colFlick)
      	}
      };
        if(iterations > 5) {
          clearInterval(colFlick)
        }
      } 
  }, 1000)
  
  
  
//   setTimeout(function() {
//     var productColorOptions = new Flickity( '#color_options_slider', {
//       prevNextButtons: true,
//       pageDots: false,
//       wrapAround: true,
//       groupCells: 4,
//       cellAlign: 'left'
//     });
//   }, 1000);
  
  
  /* 
   * Product Description Tabs
   */
  $(".product-description-section .nav-link").on("click", function(e) {
    e.preventDefault();
    
    // Highlight the new tab
    $(".product-description-section  .nav-link").removeClass("active");
    $(this).addClass("active");
    
    var target = $(this).data("target");
    
    // Show the New Tab content
    $(".product-description-section .tab-content .tab-pane").removeClass("active");
    $(".product-description-section .tab-content .tab-pane").removeClass("show");
    
    $(`.product-description-section .tab-content ${target}`).addClass("active");
    $(`.product-description-section .tab-content  ${target}`).addClass("show");
  });

  /* 
   * Customer Support Page Links on Page Load
   */
  var customer_support_hash = window.top.location.hash;
  $(".customer-support-content  .nav-link").removeClass("active");
  $(".nav .nav-link[data-target='"+ customer_support_hash +"'").addClass("active");
  
  if(window.location.href.indexOf("support") && customer_support_hash) {
    console.log("test");
    
    setTimeout(function() {
        //window.scrollTo(0, 0);
       $([document.documentElement, document.body]).animate({
          scrollTop: $("#support-content").offset().top - $("#section-header").height()

      }, 0);
      
    }, 1);
    
  }

  // Show the New Tab content
  $(".customer-support-content  .content > div").removeClass("active");
  $(`.customer-support-content  .content > ${customer_support_hash}`).addClass("active");

  /* 
   * Customer Support Page Links on click
   */
  $(".customer-support-content a[data-target]").on("click", function(e) {
    e.preventDefault();
    
    var target = $(this).data("target");
    
    $(".customer-support-content  .nav-link").removeClass("active");
    $(".nav .nav-link[data-target='"+ target +"'").addClass("active");
    
    // Show the New Tab content
    $(".customer-support-content  .content > div").removeClass("active");
    $(`.customer-support-content  .content > ${target}`).addClass("active");
  });
  
  /* 
   * Customer Support Page - Tabs on Desktop
   */
  $(".customer-support-content .nav .nav-link").on("click", function(e) {
    e.preventDefault();
    
     $([document.documentElement, document.body]).animate({
        scrollTop: $("#support-content").offset().top - $("#section-header").height()
    }, 0);
    
    // Highlight the new tab
    $(".customer-support-content  .nav-link").removeClass("active");
    $(this).addClass("active");
    
    var target = $(this).data("target");
    
    // Show the New Tab content
    $(".customer-support-content  .content > div").removeClass("active");
    $(`.customer-support-content  .content > ${target}`).addClass("active");
  });
  
  /* 
   * Customer Support Page - Selector On Mobile
   */
  $(".customer-support-content #tempSupport").on("change", function() {
    var target = $(this).find("option:selected").data("target");
    
    // Show the New Tab content
    $(".customer-support-content  .content > div").removeClass("active");
    $(`.customer-support-content  .content > ${target}`).addClass("active");
  });
  
  /*
   * Customer Support Page - Stock tabs
   */
  $(".uk-accordion .uk-accordion-title").on("click", function(e) {
    e.preventDefault();
    
    // Hide all other tabs first
    $(this).closest(".uk-accordion").find(".uk-accordion-content").addClass("hide");
    $(this).closest(".uk-accordion").find("li").removeClass("uk-open");
    
    // Show the clicked tab content
    $(this).siblings(".uk-accordion-content").removeClass("hide");
    $(this).parent("li").addClass("uk-open");

  });
  
  /*
   * Product Page - Shipping Table on Mobile
   */
  $(".mobile-shipping-table select").on("change", function() {
    var target = $(this).find("option:selected").data("target");
    
    $(this).closest(".mobile-shipping-table").find(".mobile-table-content .table-tab").removeClass("show");
    $(this).closest(".mobile-shipping-table").find(`.mobile-table-content ${target}`).addClass("show");
  });
  
  /* 
   * Change the product image when the variant changes 
   */
  $(".CustomFeaturedProducts .ColorSwatch__Radio").on("change", function() {
    var target = $(this);
    var productItem = target.closest('.ProductItem'),
        variantUrl = target.attr('data-variant-url');

    productItem.find('.ProductItem__ImageWrapper').attr('href', variantUrl);
    productItem.find('.ProductItem__Title > a').attr('href', variantUrl);

    // If we have a custom image for the variant, we change it
    var originalImageElement = productItem.find('.ProductItem__Image:not(.ProductItem__Image--alternate)');

    if (target.attr('data-image-url') && target.attr('data-image-id') !== originalImageElement.attr('data-image-id')) {
      var newImageElement = document.createElement('img');
      newImageElement.className = 'ProductItem__Image Image--fadeIn Image--lazyLoad';
      newImageElement.setAttribute('data-image-id', target.attr('data-image-id'));
      newImageElement.setAttribute('data-src', target.attr('data-image-url'));
      newImageElement.setAttribute('data-widths', target.attr('data-image-widths'));
      newImageElement.setAttribute('data-sizes', 'auto');

      // Replace the original node
      if (window.theme.productImageSize === 'natural') {
        originalImageElement.parent().css({
          "paddingBottom": 100.0 / target.attr('data-image-aspect-ratio') + '%'
        });
      }

      originalImageElement.parent().css({
        "--aspect-ratio": target.attr('data-image-aspect-ratio')
      });
      
      originalImageElement.parent().html(newImageElement);
    }
  });
  
  // Signup/Signin Modal Form
  $(".form-wrapper a.toggle").on("click", function(e) {
    e.preventDefault();
    $(this).parents(".form-wrapper").removeClass("active");
    var target = $(this).attr("href");
    $(`${target}`).addClass("active");
  });
  
  /*
   * Header SearchBar 
   */
  $("#Search .Search__Input").on("keyup keydown", function() {
    if($(this).val() == "") {
      $("#Search .searchBar_footer").removeClass("hide");
    } else {
      $("#Search .searchBar_footer").addClass("hide");
    }
  });
  
  /*
   * Vimeo Video Play Button
   */
  $(".vimeo-play-button").on("click", function() {
    var iframe = $(this).parent().find(".custom-vimeo-video");
    var player = new Vimeo.Player(iframe);

    player.play().catch(function(error) {
      console.error('error playing the video:', error.name);
    });
    
    $(this).hide();
    $(this).siblings(".vimeo-pause-button").css("display", "flex");
  });
  
  /*
   * Vimeo Video Pause Button
   */
  $(".vimeo-pause-button").on("click", function() {
    var iframe = $(this).parent().find(".custom-vimeo-video");
    var player = new Vimeo.Player(iframe);

    player.pause().catch(function(error) {
      console.error('error pausing the video:', error.name);
    });
    
    $(this).hide();
    $(this).siblings(".vimeo-play-button").css("display", "flex");
  });
  
  /*
   * Read More button in product description
   */
  
  function readMore() {
    document.querySelector(".read-more-text").classList.toggle("active");
    if( this.textContent.toLowerCase().indexOf("more") != -1) {
      this.textContent = "Read Less";
    } else {
      this.textContent = "Read More";
    }
  }
  
  var ProductReadMoreButton = document.querySelector(".read-more-btn");
  if(ProductReadMoreButton) {
    ProductReadMoreButton.addEventListener("click", readMore, false);
    ProductReadMoreButton.addEventListener("touchstart", readMore, false);
  }
  
  // embroidery product template
  $("#js-initials-color").on("click", ".selected", function() {
    $(this).parent().removeClass("hide-other-options");
    $("#js-initials-color .js-initials-single-color").removeClass("selected");
  });
  
  $("#js-initials-color").on("click", ".js-initials-single-color:not(.selected)", function() {
    var color = $(this).data("color");
    $("#js-initials-color .js-initials-single-color").removeClass("selected");
    $(`#js-initials-color [data-color="${ color }"]`).addClass("selected");
    $("#initials-color").val(color).trigger("change");
    $(this).parent().addClass("hide-other-options");
  });
  
  $('.custom-collection-filters .Collapsible__Button').on('click', function(e) {
    e.stopPropagation();
    var ll = $(this).siblings('.Collapsible__Inner').find('.Linklist');
    ll.slideToggle()
  })

  $('.color-label').on('click', function(e) {
    e.stopPropagation();
    $(this).prev().trigger('click');
  })
  $(document).click(function(e) {
    if(!$(e.target).hasClass('Linklist__Item') && !$(e.target).hasClass('filter-tag-button')) {
      $('.custom-collection-filters .Collapsible__Inner .Linklist').slideUp();
    }
  });
  
  $('.filter-bar-mobile').on('click', function(e) {
    e.stopPropagation();
    $('.filters-custom-container').slideToggle();
  })
  $('.tag-input').on('click', function(e) {
    $(this).next('button').trigger('click');
  })
  $(window).on('resize', function() {
    if ($(window).width() > 1007) {
      $('.filters-custom-container').css("display", "block");
    }
  })
  
//   document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//    bubbles: true
//  }));
  
//   $('.popup-single-variant-available').on('click', function(e) {
//     e.stopPropagation();
//     var value = $(this).text()
//     console.log(value)
//     $(this).siblings().removeClass('active-variant')
//     $(this).addClass('active-variant');
//     var $select = $(this).parent().next().find('select');
// 	$select.val($select.find('option[data-variant="' + value + '"]').val());
   
//   })
  
//   $('.popup-img-container').on('touchstart', function(e) {
//     e.stopPropagation();
//     if(!$(e.target).hasClass('money') && !$(e.target).hasClass('popup-single-variant') && !$(e.target).hasClass('ProductForm__AddToCart') && !$(e.target).hasClass('atc-span')) {

//     var onhover = $(this).find('.product-onhover');
//     var overlay = $(this).find('.popup-img-overlay');
//     console.log(onhover)
//     console.log(overlay)
//     if(onhover.hasClass('onhover-show')) {
//        onhover.removeClass('onhover-show');
//        overlay.removeClass('overlay-show');
//     }
//     else {
//       onhover.addClass('onhover-show')
//       overlay.addClass('overlay-show')
//     }
//     }
//   })
//   $('.popup-products-container').on('touchstart', function(e) {
//     $('.product-onhover').removeClass('onhover-show');
//     $('.popup-img-overlay').removeClass('overlay-show');
//   })

//   var variants = document.querySelectorAll('.popup-single-variant');
  
//   variants.forEach(variant => {
//     variant.addEventListener('click', function(e) {
//       var clickedVariant = e.target
//       variants.forEach(var => {
//       	var.classList.remove('active-variant')
//     })
//       clickedVariant.classList.add('active-variant')
//   })
// })
  if ($(window).width() >= 1007) {
    var height = $('.CollectionInner__Christmas-row .ProductItem__Image--alternate').innerHeight();
    $('.custom-christmas-row-right').innerHeight(height);
  }
  
  $(window).on('resize', function(){
    if ($(window).width() >= 1007) {
      var height = $('.CollectionInner__Christmas-row .ProductItem__Image--alternate').innerHeight();
      $('.custom-christmas-row-right').innerHeight(height);
    }
    else {
      $('.custom-christmas-row-right').innerHeight('auto');
    }
  })

  var ProductReadMoreButton = document.querySelector(".read-more-btn");
  if(ProductReadMoreButton) {
    ProductReadMoreButton.addEventListener("click", readMore, false);
    ProductReadMoreButton.addEventListener("touchstart", readMore, false);
  }
  
//   var wholesale_table = document.querySelector(".table_all_variants")

//   if(wholesale_table){
//     $('.table_all_variants .quantity:first').focus();
//     $('[max]').change(function() {
//       var max = parseInt($(this).attr('max'), 10);
//       var value = parseInt($(this).val(), 10) || 0;
//       if (value > max) { 
//         alert('We only have ' + max + ' of this item in stock');
//         $(this).val(max); 
//       }
//       if (value == ""){
//         $(this).val(0);
//       }
//     });

//     $(document).ready(function(){
//       var quantity_fields = $(".inquiry.quantity.field");
//       var _ind = [];
//       $(quantity_fields).each(function(i){
//         $(this).change(function(e){
//           $(this).attr("value",e.target.value);
//           if($(this).attr("value") > 0){
//             _ind.push(i);
//             var variants_within = $(this).closest(".variants__within");
//             var product_title = $(this).data("product-title");
//           	var variant_title = $(this).data("variant-title");
//             var variant_price = $(this).data("price");
//             var variant_quantity = $(this).attr("value");

//             $(variants_within).append(`
//           <input class="contact__input-field" type="text" style="display:none" name="contact[Title__${_ind.length}]" value="${product_title}"/>
//           <input class="contact__input-field" type="text" style="display:none" name="contact[Variant__${_ind.length}]" value="${variant_title}"/>
// 		  <input class="contact__input-field" type="text" style="display:none" name="contact[Price__${_ind.length}]" value="${variant_price}"/>
//           <input class="contact__input-field" type="text" style="display:none" name="contact[Quantity__${_ind.length}]" value="${variant_quantity}"/>
//           `);
//           } else {
//             _ind.pop(i);
//            $(this).closest(".variants__within").find(".contact__input-field").remove();
//           }
//         });
//       });
      
// // 	  Cookie for the first time wholesale visitors
      
//       function newCookie(name, value, days) {
//         if(days){
//           var date = new Date();
//           date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
//           var expires = "; expires=" + date.toGMTString();
//         }
//         else var expires = "";
//         document.cookie = name + "=" + value + expires + "; path=/";
//       }

//       function readCookie(name) {
//         var nameEQ = name + "=";
//         var ca = document.cookie.split(';');
//         for (var i = 0; i < ca.length; i++) {
//           var c = ca[i];
//           while (c.charAt(0) == ' ') c = c.substring(1, c.length);
//           if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
//         }
//         return null;
//       }

//       var cookie = readCookie("wholesale_note");
//       var pop_up_close = $(".wholesale__pop-up__close");

//       if(!cookie) {
//         newCookie("wholesale_note", "true", 30);
//         $(pop_up_close).click(function(){
//           $("#shopify-section-wholesale__pop-up").addClass("w-p__hidden");
//         });
//       }else {
//         console.log("wh_p__already-initiated");
//         $("#shopify-section-wholesale__pop-up").addClass("w-p__hidden");
//       }
      
      
//     });
//   }

  // Cookie for the first time wholesale visitors

  $(document).ready(function(){

    function newCookie(name, value, days) {
      if(days){
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "; expires=" + date.toGMTString();
      }
      else var expires = "";
      document.cookie = name + "=" + value + expires + "; path=/";
    }

    function readCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }

    var cookie = readCookie("wholesale_note");
    var pop_up_close = $(".wholesale__pop-up__close");

    if(!cookie) {
      newCookie("wholesale_note", "true", 30);
      $(pop_up_close).click(function(){
        $("#shopify-section-wholesale__pop-up").addClass("w-p__hidden");
      });
    }else {
      $("#shopify-section-wholesale__pop-up").addClass("w-p__hidden");
    }

	//  wholesale max quantity

    $('.Wholesale__Quantity').on("input", function() {
      var max = parseInt($(this).attr('max'));
      var value = parseInt($(this).val());
      if (value > max) {
        alert('Maximum order quantity is ' + max);
        $(this).val(max); 
      }
    });
    
  });
  
})();

$(document).ready(function(){
  $('.ad_to_cart_coll').click(function(e){ 
    e.preventDefault();
    var $this = this;
    var ID = $($this).closest('form').find(".quick-add__variants").find(".variant__selected").attr('value');
    addItemToCart(ID, 1)
    $('.cart_dr').trigger("click");
  });
  
  
  $('body').on("click", ".snize-product .ad_to_cart_coll",function(e){ 
    e.preventDefault();
    var $this = this;
    console.log($this);
    var ID = $($this).closest('form').find(".quick-add__variants").find(".variant__selected").attr('value');
    addItemToCart(ID, 1)
    $('.cart_dr').trigger("click");
  });
  
  function addItemToCart(variant_id, qty) {
    data = {
      "id": variant_id,
      "quantity": qty
    }
    console.log(data)
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true 
        }));
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                variant: variant_id,
                quantity: qty
              }
            }));
      }   
    }); 
  };
});

$(document).ready(function(){
  $(".quick-add__variant").click(function(){
    var $this = this;
    if(!$($this).hasClass("variant__selected")){
      $(this).parent().children().removeClass("variant__selected");
      $(this).addClass("variant__selected");
      $(this).closest("form").find('[name="id"]').val($(this).attr('value'));
  
    }
  });
  
  
  $("body").on("click", ".quick-add__variant", function(){
    var $this = this;
    
    if(!$($this).hasClass("variant__selected")){
      $(this).parent().children().removeClass("variant__selected");
      $(this).addClass("variant__selected");
      $(this).closest("form").find('[name="id"]').val($(this).attr('value'));
  
    }
  });
});

$(document).ready(function(){
  $(".Product__SlideshowNavScroller").flickity({
    contain: true
  });
});

$(document).ready(function(){
  $(".ProductForm__AddToCart").click(function(){
    $(".stl-popup-link").click();
  });
});

$(document).ready(function(){
  $(".expand-stl-quick_add").click(function(){
    if($(this).parent().find(".stl-quick-shop").hasClass("hidden")){
      $(this).parents().find(".stl-quick-shop").addClass("hidden");
      $(this).parents().find(".expand-stl-quick_add").removeClass("hidden");
      $(this).addClass("hidden");
      $(this).parent().find(".stl-quick-shop").removeClass("hidden");
    }
  });
});

$(document).ready(function(){
  $('.ad_to_cart_coll').click(function(e){ 
    e.preventDefault();
    var $this = $(this);
    let isAvailable = 'true';
    var result = [];
    var ID = $($this).closest('form').find(".quick-add__variants").find(".variant__selected").attr('value');
    var quantity = $($this).closest('form').find(".quick-add__variants").find(".variant__selected").data("quantity");
    var url = '/variants/' + ID + '.js';
    var url2 = '/cart.js';
    jQuery.ajax({
      type: 'GET',
      url: url2,
      success: function(data) { 
        doSomethingWithApiData(data)
      }
    });
    function doSomethingWithApiData(arr){
		var elem = JSON.parse(arr);
      for(var i=0; i<elem.items.length;i++){
        if(elem.items[i].id == ID){
          if(elem.items[i].quantity == quantity){
            isAvailable = 'false';
            $($this).closest('form').find(".quick-add__variants").find(".variant__selected").addClass("unavailable-variant");
          }
        }
      }
    }
  });
});

$(document).ready(function(){
  if($(window).width()>787){
  var windowWidth = $(window).width();
  $(".quick-add-section").each(function(){
    
    var $this = $(this);
    var $grid = $this.parents('.ProductItem');
    var offsetRight = $grid.offset().left + $grid.width();
    if(windowWidth - offsetRight < 280){
      $this.addClass("right-offset");
      $this.find(".arrow-icon-left").addClass("hidden");
    }
    else{
      $this.addClass("left-offset");
      $this.find(".arrow-icon-right").addClass("hidden");
    }
  });
  }
  else{
    $(".quick-add-section").each(function(){
    var $this = $(this);
    $this.addClass("hidden");
    });
  };
});

// $(document).ready(function(){
//   var collectionItem = $(".ProductList .Grid__Cell .ProductItem");
//   $(collectionItem).hover(function() {
//     var $this = $(this);
//     $this.parent().next().find(".ProductItem").addClass("sibling_active");
//   }, function() {
//     var $this = $(this);
//     $this.parent().next().find(".ProductItem").removeClass("sibling_active");
//   });
// });

$(document).ready(function(){
  var timeout;
  
//   var collectionPopup = function(event) {
//     let $this = $(event.target);
//     let $item = $this.closest(".ProductItem");

//     if(event.type == "mouseover") {
//       if($this.closest(".Carousel__Cell").length > 0) {
//         let carouselContainer = $this.closest(".Carousel__Cell").parent().parent();
//         let carouselContainerWidth = carouselContainer.width();
//         var elem = $this.closest(".Carousel__Cell");
//         var cellPosition = elem.offset().left - elem.parent().parent().offset().left;
//         let position = "right";
//         let calcWidth = carouselContainerWidth / 2;

//         if(cellPosition >= calcWidth) {
//           position = "left";
//         }

//         $item.removeClass("left right");
//         $item.addClass(position);
//       }

//       $item.find(".quick-add-section").addClass("display__section");
//     } else {
      
//       $item.find(".quick-add-section").removeClass("display__section");
//     }
//   }
  
//   $("body").on("mouseover mouseout", ".ProductRecommendations", function(event) { collectionPopup(event); });
  
//   $(".grid-newborn").on("mouseover mouseout", ".ProductItem", function(event) { collectionPopup(event); });
  
  
//   $(".ProductItem").on('mouseover', function(e){
//     var $this = $(this);
//     e.preventDefault();
//     timeout = setTimeout(function(){
//       $this.find(".quick-add-section").addClass("display__section");
//     }, 500);
//   }) 
//   $(".ProductItem").on('mouseout', function(e) {
//     var $this = $(this);
//     e.preventDefault();
//     clearTimeout(timeout)
//     if (!$this.find(".quick-add-section").is(":hover")) {
//       $this.find(".quick-add-section").removeClass("display__section");
//     }
//   });
});

// $(document).ready(function(){
//   $(".ProductItem").hover(function(e){
//     e.preventDefault();
//     var $this = $(this);
//         setTimeout(function(){
//           $this.find(".quick-add-section").addClass("display__section");
//         }, 1000);
//   }, function(){
//      $(this).find(".quick-add-section").removeClass("display__section");
//   });
// });

function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = format || '${{amount}}';

  function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ',');
    decimal = defaultTo(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
        dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  var value = '';

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, ',', '.');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
  }

  if (formatString.indexOf('with_comma_separator') !== -1) {
    return formatString.replace(placeholderRegex, value).replace(',00', '');
  } else {
    return formatString.replace(placeholderRegex, value).replace('.00', '');
  }
}
$(document).ready(function(){
  $(".quick-add__variant").click(function(e){
    e.preventDefault();
    var $this = $(this);
    var id = $($this).attr('value');
    $($this).closest('.quick-add-section').find(".BIS_trigger").data('variant-id', id);
    
    //!!!!!!!!!!!!!!!!!!!!
     // $(this).closest("form").find('.price').html(formatMoney($(this).attr('data-price'), window.theme.moneyFormat)) ;
  });
});


$(document).ready(function(){
  $(".accordion-title").click(function(){
    if(!$(this).parent().hasClass("display-accordion")){
    $(this).parent().addClass("display-accordion");
    $(this).parent().find(".accordion-content").slideDown(400);
      $(this).find('.circle-plus').addClass("opened");
  }
     else{
       $(this).parent().removeClass("display-accordion");
       $(this).parent().find(".accordion-content").slideUp(400);
        $(this).find('.circle-plus').removeClass("opened");
}    
  });
});

$(document).ready(function(){
  if($(window).width() > 768 ){
    $(window).scroll(function(){
      var windowPosition = $(window).scrollTop();
      var elementLink = $(".Product__Slideshow");
      if(elementLink.length > 0) {
        var elementOffset = elementLink.offset();
        var elementTop = elementOffset.top;
        if(windowPosition < elementTop){
          $(".Product__Gallery").css('position', 'sticky');
          $(".Product__Gallery").css('top', '150px'); 
        }
      }
    });
  }
});

// $(document).ready(function() {
//    $('ul.tabs').each(function(){
//      var active, content, links = $(this).find('a');
//      active = links.first().addClass('active');
//      content = $(active.attr('href'));
//      links.not(':first').each(function () {
//        $($(this).attr('href')).hide();
//      });
//      $(this).find('a').click(function(e){
//        active.removeClass('active');
//        content.hide();
//        active = $(this);
//        content = $($(this).attr('href'));
//        active.addClass('active');
//        content.show();
//        return false;
//      });
//    });
//  });

$(window).on('load', function(){
  $(".SizeSwatch.is-active::after, .SizeSwatch__Radio:checked+.SizeSwatch").css('border', '1px solid #ddd');
  $(".SizeSwatch").click(function(){
    $(this).closest(".SizeSwatchList").find(".SizeSwatch").css('border', '1px solid #ddd');
    $(this).css('border', '1px solid black');
  });
});

$(document).ready(function(){
  $(".SizeSwatchList > li").click(function(){
    if(!$(this).find('label').hasClass("soldout")){
      $(".ProductForm__AddToCart").removeClass("hidden");
    }
    else{
      $(".ProductForm__AddToCart").addClass("hidden");
    }
  })
});

$(document).ready(function(){
  $(".mobile-shipping-table select").on("change", function() {
    var target = $(this).find("option:selected").data("target");
    $(this).closest(".mobile-shipping-table").find(".mobile-table-content .table-tab").removeClass("show");
    $(this).closest(".mobile-shipping-table").find(`.mobile-table-content ${target}`).addClass("show");
  });
});

$(document).ready(function(){
  $(".product-custom-slider").flickity({
    pageDots: false,
    prevNextButtons: false,
    freeScroll: true,
    wrapAround: true,
    autoPlay: 3000
  });
});

$(document).ready(function(){
  $(".filters-custom-container .Linklist__Item").click(function(){
    var toAssign = $(this).find("button").data("tag");
    var withTag = toAssign.replaceAll('-', ' ');
    var toReturn = withTag.substring(withTag.indexOf("_") + 1);
    $(this).closest(".Collapsible--autoExpand").find(".Collapsible__Button").text(toReturn);
  });
});

$(document).ready(function(){
  $(".reset-filters").click(function(){
    $(".filters-custom-container .Collapsible--autoExpand").each(function(){
      $(this).find(".Collapsible__Button").text($(this).data("return"));
    });
  });
});

//Newborn section code

$(document).ready(function () {    
    $('.mobile-newborn-open').click(function () {    
        var id = '#dialog';    
        var clgName = $('#cllg').val();    
        $("#clg").val(clgName);    
       var maskHeight = $(document).height();    
        var maskWidth = $(document).width();    
        $('#mask').css({ 'width': maskWidth, 'height': maskHeight })    
        $('#mask').fadeTo("slow", 0.8);    
        var winH = $(window).height();    
        var winW = $(window).width();    
        $(id).css('top', winH / 2 - $(id).height() / 2);    
        $(id).css('left', winW / 2 - $(id).width() / 2);    
        $(id).fadeIn(300);    
        $('.window .close').click(function (e) {    
            e.preventDefault();    
            $('#mask').hide();    
            $('.window').hide();    
        });    
    });    
});


$(document).ready(function () {    
    $('.newborn-button').click(function () {    
        var id = '#dialog';    
        var clgName = $('#cllg').val();    
        $("#clg").val(clgName);    
       var maskHeight = $(document).height();    
        var maskWidth = $(document).width();    
        $('#mask').css({ 'width': maskWidth, 'height': maskHeight })    
        $('#mask').fadeTo("slow", 0.8);    
        var winH = $(window).height();    
        var winW = $(window).width();    
        $(id).css('top', winH / 2 - $(id).height() / 2);    
        $(id).css('left', winW / 2 - $(id).width() / 2);    
        $(id).fadeIn(300);    
        $('.window .close').click(function (e) {    
            e.preventDefault();    
            $('#mask').hide();    
            $('.window').hide();    
        });    
    });    
});
 

$(document).ready(function(){
  $(".images-slideshow-quiz").flickity({
  	freeScroll: false,
    autoPlay: true,
    autoPlay: 5000,
    pageDots: false,
    prevNextButtons: false,
    wrapAround: true,
    draggable: false
  });
});

$(".images-slideshow-quiz").on( 'ready.flickity', function() {
  $(this).find(".animated-zoom").removeClass('animated-zoom');
  $(this).find(".is-selected").addClass('animated-zoom');
});

$(".images-slideshow-quiz").on( 'settle.flickity', function( event, index ) {
  $(this).find(".animated-zoom").removeClass('animated-zoom');
  $(this).find(".is-selected").addClass('animated-zoom');
});

$(document).ready(function (){
  $(".newborn-quiz-button").click(function (){
    $(".quiz-newborn-wrapper").fadeIn("slow");
  });
  $(".close").click(function (){
    $(".quiz-newborn-wrapper").fadeOut("slow");
  });
});

$(document).ready(function (){
  $(".pregnant-quiz-button").click(function (){
    $(".quiz-pregnant-wrapper").fadeIn("slow");
  });
  $(".close").click(function (){
    $(".quiz-pregnant-wrapper").fadeOut("slow");
  });
});

$(document).ready(function (){
  $(".toggle-quiz-newborn").click(function (){
    $(".quiz-newborn-wrapper").fadeIn("slow");
  });
  $(".close").click(function (){
    $(".quiz-newborn-wrapper").fadeOut("slow");
  });
});

$(document).ready(function (){
  $(".toggle-quiz-pregnant").click(function (){
    $(".quiz-pregnant-wrapper").fadeIn("slow");
  });
  $(".close").click(function (){
    $(".quiz-pregnant-wrapper").fadeOut("slow");
  });
});


$(document).ready(function (){
  if(window.location.href.indexOf("newborn?quiz=open") > 0) {
    $(".quiz-newborn-wrapper").fadeIn("slow");
  }
  
  if(window.location.href.indexOf("pregnant?quiz=open") > 0) {
    $(".quiz-pregnant-wrapper").fadeIn("slow");
  }
});
//Newborn section code end

// https://shirleybredal.com/?newborn=true

$(document).ready(function(){
function getURLParameter(name) {
    return decodeURI(
        (RegExp(name + '=' + '(.+?)(&|$)').exec(location.search)||[,null])[1]
    );
}

  if(getURLParameter('newborn') == 'true'){
      $(".newborn-button").trigger('click');
    }
});

$(document).ready(function(){
  $(".menu-newborn-open").trigger('click');
});

$(document).ready(function(){
  $(".upsell-options-slider").flickity({
    pageDots: false,
    wrapAround: true,
    groupCells: 4,
    cellAlign: 'left',
    draggable: true
  });
});

$(document).ready(function(){
  $('.upsell-variant-select').change(function(e){ 
    e.preventDefault();
    var $this = this;
    var ID = $($this).find(':selected').data("variant");
    if(ID != 0){
    addItemToCart(ID, 1, $this);
    $('.cart_dr').trigger("click");
    setTimeout(function(){ $($this).val('Select size'); }, 1500);
    
    }
  });
  
  $('.upsell-variant-button').click(function(e){ 
    e.preventDefault();
    var $this = this;
    var ID = $($this).data("id");
    
    if(ID != 0){
      
      $($this).addClass("load");
      addItemToCart(ID, 1, $this);
      $('.cart_dr').trigger("click");
    }
  });
  
  
  function addItemToCart(variant_id, qty, $this) {
    data = {
      "id": variant_id,
      "quantity": qty
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true 
        }));
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                variant: variant_id,
                quantity: qty
              }
            }));
        
        
      setTimeout(function() {
        $($this).removeClass("load");
      }, 250);
      }   
    }); 
  };
});


document.addEventListener('DOMContentLoaded', function() {
  var resizeEvent = new Event('resize');
  window.dispatchEvent(resizeEvent);
}, false);



// jQuery.ajax({
//     type: 'POST',
//     url: '/cart/update.js',
//     data: {"updates": {40063993184279: 1}},
//     dataType: 'json',
//     success: function() { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));}   
//   }); 